import './Footer.scss';
import React, { memo } from 'react';

interface FooterProps {
  isHomePage?: boolean;
}

export const Footer: React.FC<FooterProps> = memo(({ isHomePage }) => (
  <footer className={isHomePage ? 'home-page' : ''}>
    <p>© tuksums 2026 &nbsp; | &nbsp; ALL RIGHTS RESERVED &nbsp; | &nbsp; info@tuksums.lv</p>
  </footer>
));